import StoredFilters from 'utils/stored_filters';
import ModalManager from 'utils/modal_manager';
import 'utils/serialize_object';

(function ($) {
  'use strict';

  $('.js-filter-form').on('click', '.js-btn-save', (event) => {
    const $button = $(event.currentTarget);
    const {segmentId, product, limitReached} = $button.data();

    if (limitReached === true) return;

    ModalManager.open('#js-new-filter-modal', (formData, $formEvent) => {
      const name = $formEvent.find('[name="filter-name"]').val();
      const serialized = $('.js-filter-form').serializeObject();

      StoredFilters.save(name, product, segmentId, serialized, $button);
    });
  });

})(jQuery);

